module.exports = __webpack_public_path__ + "static/media/sixteenth_viewpoint_bookstore1.bdbca841.JPG";